import React, { useEffect, useState } from "react";
import Slider from 'react-slick';
import { ReactComponent as Morning } from "../../../images/mdi_wb_morning.svg";
import { ReactComponent as Afternoon } from "../../../images/mdi_wb_afternoon.svg";
import { ReactComponent as Evening } from "../../../images/mdi_wb_evening.svg";

const Left = (props) => (
  <div
    className={"arrow shadow-none p-0 " + props.className}
    style={{ left: `15px` }}
    onClick={props.onClick}
  >
    <svg
      version="1.1"
      id="Layer_1"
      width="1rem"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 492 492"
      xmlSpace="preserve"
    >
      <g>
        <g>
          <path
            d="M198.608,246.104L382.664,62.04c5.068-5.056,7.856-11.816,7.856-19.024c0-7.212-2.788-13.968-7.856-19.032l-16.128-16.12
C361.476,2.792,354.712,0,347.504,0s-13.964,2.792-19.028,7.864L109.328,227.008c-5.084,5.08-7.868,11.868-7.848,19.084
c-0.02,7.248,2.76,14.028,7.848,19.112l218.944,218.932c5.064,5.072,11.82,7.864,19.032,7.864c7.208,0,13.964-2.792,19.032-7.864
l16.124-16.12c10.492-10.492,10.492-27.572,0-38.06L198.608,246.104z"
          />
        </g>
      </g>
    </svg>
  </div>
);

const Right = (props) => (
  <div
    className={"arrow shadow-none p-0 " + props.className}
    style={{ right: `15px` }}
    onClick={props.onClick}
  >
    <svg
      version="1.1"
      width="1rem"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 451.846 451.847"
      xmlSpace="preserve"
    >
      <g>
        <path
          d="M345.441,248.292L151.154,442.573c-12.359,12.365-32.397,12.365-44.75,0c-12.354-12.354-12.354-32.391,0-44.744
      L278.318,225.92L106.409,54.017c-12.354-12.359-12.354-32.394,0-44.748c12.354-12.359,32.391-12.359,44.75,0l194.287,194.284
      c6.177,6.18,9.262,14.271,9.262,22.366C354.708,234.018,351.617,242.115,345.441,248.292z"
        />
      </g>
    </svg>
  </div>
);

const Days = ({ days: total}) => {
  const [shownIndex, setShownIndex] = useState(0);
  const [slidesToShow,setSlides] = useState(3);
  useEffect(()=>{
    setSlides(window.innerWidth> 992 ? 3 : 2)
  },[]);

  const config = {
    slidesToShow,
    slidesToScroll: slidesToShow,
    infinite: false,
    dots: false,
    speed: 500,
    arrows: window.innerWidth > 576 ? true : false,
    prevArrow: <Left />,
    nextArrow: <Right />,
    afterChange: (i)=> setShownIndex(i),
  }
  return (
    <div className="days">
      <div className="container-fluid position-relative overflow-hidden">
        <Slider {...config}>
            {total.map((el, i) => {
              const months = ["Jan","Feb","March","April","May","June","July","Aug","Sep","Oct","Nov","Dec"];
              return (
                <div
                  onClick={() => setShownIndex(i)}
                  className={`px-1 my_slide position-relative py-2 ${i === shownIndex ? "active_slide" : ""}`}
                  key={i}
                >
                  <h6 className="text-uppercase">
                    {new Date().getDate() + i} {months[new Date().getMonth()]}
                  </h6>
                  <p className="mb-0 h3desc">
                    {Math.floor(Math.random() * 20)} Slots Available
                  </p>
                </div>
              );
            })}
        </Slider>
      </div>
      <div className="container-fluid pt-4 pb-3">
        {total[shownIndex].morning && total[shownIndex].morning.length > 0 ? (
          <div className="row my-1">
            <div className="col-lg-3 font-weight-bold h3desc text-left text-left py-3">
              <Morning className="mr-2" /> Morning:
            </div>
            <div className="col-lg-9 text-left py-3">
              <div className="row">
                {total[shownIndex].morning.map((el, i) => (
                  <div className="col-lg-3 col-4 px-1" key={i}>
                    <span
                      className={`time w-100 text-center py-2 h3desc font-weight-bold ${
                        el.isAvailable && "available"
                      }`}
                    >
                      {el.time}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
        {total[shownIndex].afternoon &&
        total[shownIndex].afternoon.length > 0 ? (
          <div className="row my-1">
            <div className="col-lg-3 font-weight-bold h3desc text-left text-left py-3">
              <Afternoon className="mr-2" /> Afternoon:
            </div>
            <div className="col-lg-9 text-left py-3">
              <div className="row">
                {total[shownIndex].afternoon.map((el, i) => (
                  <div className="col-lg-3 col-4 px-1" key={i}>
                    <div
                      className={`time w-100 text-center py-2 h3desc font-weight-bold ${
                        el.isAvailable && "available"
                      }`}
                    >
                      {el.time}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
        {total[shownIndex].evening && total[shownIndex].evening.length > 0 ? (
          <div className="row my-1">
            <div className="col-lg-3 font-weight-bold h3desc text-left text-left py-3">
              <Evening className="mr-2" /> Evening:
            </div>
            <div className="col-lg-9 text-left py-3">
              <div className="row">
                {total[shownIndex].evening.map((el, i) => (
                  <div className="col-lg-3 col-4 px-1" key={i}>
                    <div
                      className={`time py-2 w-100 text-center h3desc font-weight-bold ${
                        el.isAvailable && "available"
                      }`}
                    >
                      {el.time}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default Days;
